import { render, staticRenderFns } from "./Users-registration.vue?vue&type=template&id=05fcf75e&"
import script from "./Users-registration.vue?vue&type=script&lang=js&"
export * from "./Users-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports